import { z } from 'zod';

export const PhasesCO2Schema = z.object({
	a1: z.number(),
	a2: z.number(),
	a3: z.number(),
	a4: z.number(),
	a5: z.number(),
	c1: z.number(),
	c2: z.number(),
	c3: z.number(),
	c4: z.number(),
	d: z.number(),
});

export type IPhasesCO2Schema = z.infer<typeof PhasesCO2Schema>;
